import React, { useEffect, useState, Fragment } from 'react'
import { Button, Col, Container, Form, Row, Modal, Card } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'


const DetallesCabecera = () => {
  
  // El hook useSelector (redux) permite acceder al state en nuestro store.
  const data_datos_generales = useSelector((state) => state.casoGeneralReducer)
  const { antecedentesCasos, cfg_form33 } = data_datos_generales

  const [showModalContacto, setShowModalContacto] = useState(false);
    const [contactoApoderado, setContactoApoderado] = useState({
      email: '',
      fono: '',
      movil: ''
    });
    const handleCloseContacto = () => setShowModalContacto(false);
    const handleShowContacto = () => {
      const datos = antecedentesCasos?.antecedentesCasos?.[0] || {};
  
      setContactoApoderado({
        email: datos['EmailApoderadoCia'] || 'No informado',
        fono: datos['FonoApoderadoCia'] || 'No informado',
        movil: datos['MovilApoderadoCia'] || 'No informado'
      });
  
      setShowModalContacto(true);
    };

  // El hook useDispatch (redux) permite invocar una action.
  const dispatch = useDispatch()
  
  return (
    <>
      
    
   
      {cfg_form33 ? (
        <Form.Group className='mb-3'>
        <div>
          <Row>
            
            <Col md='3'>
              <Form.Label
                className='mb-0 mt-2'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form33.cfg_form33['detalleconsulta-lbl-sinitipo']}
              </Form.Label>{' '}
              <br />
              <Form.Text className='mb-3'>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos?.antecedentesCasos[0]['Siniestro']+" - " + antecedentesCasos?.antecedentesCasos[0]['TipoSiniestro']
                  : null}
              </Form.Text>
            </Col>
            <Col md='2'>
              <Form.Label
                className='mb-0 mt-2'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form33.cfg_form33['detalleconsulta-lbl-fechasin']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0][
                      'FechaSiniestroFormat'
                    ]
                  : null}
              </Form.Text>
            </Col>
            
            <Col md='3'>
              <Form.Label
                className='mb-0 mt-2'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form33.cfg_form33['detalleconsulta-lbl-tipgestion']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0]['TipoGestion']
                  : null}
              </Form.Text>
            </Col>
            <Col md='2'>
              <Form.Label
                className='mb-0 mt-2'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form33.cfg_form33['detalleconsulta-lbl-ambitogest']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0]['AmbitoGestion']
                  : null}
              </Form.Text>
            </Col>
            <Col md='2'>
              <Form.Label
                className='mb-0 mt-2'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form33.cfg_form33['detalleconsulta-lbl-estadocaso']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0]['EstadoCaso']
                  : null}
              </Form.Text>
            </Col>
            <Col md='1'></Col>
          </Row>
          <Row>
            <Col md='3'>
              <Form.Label
                className='mb-0 mt-3'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form33.cfg_form33['detalleconsulta-lbl-patente']}
              </Form.Label>{' '}
              <br />
              <Form.Text className='mb-3'>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos?.antecedentesCasos[0]['Patente']
                  : null}
              </Form.Text>
            </Col>
            <Col md='2'>
              <Form.Label
                className='mb-0 mt-3'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form33.cfg_form33['detalleconsulta-lbl-corredor']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0][
                      'Corredor'
                    ]
                  : null}
              </Form.Text>
            </Col>
            
            <Col md='3'>
              <Form.Label
                className='mb-0 mt-3'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form33.cfg_form33['detalleconsulta-lbl-segurotro']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0]['SeguroTercero']
                  : null}
              </Form.Text>
            </Col>
            <Col>
              <Form.Label
                className='mb-0 mt-3'
                style={{ fontWeight: 'bold', fontSize: '14px' }}
              >
                {cfg_form33.cfg_form33['detalleconsulta-lbl-responsable']}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0]['ResponsableAsignado']
                  : null}
              </Form.Text>
            </Col>
           <Col>
              <Form.Label
                className='mt-3 mb-0'
                style={{ fontWeight: 'bold', fontSize: '14px', cursor: 'pointer' }}
                onClick={handleShowContacto}
              >
                {cfg_form33.cfg_form33['detalleconsulta-lbl-apoderadocia'] ? cfg_form33.cfg_form33['detalleconsulta-lbl-apoderadocia'] : 'Apoderado Cía'}
              </Form.Label>
              <br />
              <Form.Text className='mb-3' style={{ fontSize: '14px', cursor: 'pointer' }} onClick={handleShowContacto}>
                {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                  ? antecedentesCasos.antecedentesCasos[0]['ApoderadoCia']
                  : null}
              </Form.Text>
            </Col>
          </Row>
                  </div>
    </Form.Group>
      ) : null}

      <Modal show={showModalContacto} onHide={handleCloseContacto} centered>
        <Card>
          <Card.Header
            className='mt-0 mb-0'
            as='h6'
            style={{ backgroundColor: '#4F517A', color: 'white' }}
          >
            Contacto Apoderado
          </Card.Header>

          <Card.Body>
            <Row className='mt-2 mb-3'>
              <Col>
                <Form.Label style={{ fontWeight: 'bold' }}>Email:</Form.Label>{' '}
                <Form.Text>{contactoApoderado.email}</Form.Text>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Label style={{ fontWeight: 'bold' }}>Fono:</Form.Label>{' '}
                <Form.Text>{contactoApoderado.fono}</Form.Text>
              </Col>
              <Col>
                <Form.Label style={{ fontWeight: 'bold' }}>Móvil:</Form.Label>{' '}
                <Form.Text>{contactoApoderado.movil}</Form.Text>
              </Col>
            </Row>
          </Card.Body>

          <Card.Footer style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button variant='secondary' onClick={handleCloseContacto}>
              Cerrar
            </Button>
          </Card.Footer>
        </Card>
      </Modal>
    </>
  )
}

export default DetallesCabecera
